/* eslint-disable max-len */

export const external_urls = {
    companieshouse: 'https://find-and-update.company-information.service.gov.uk/company',
    facebook: 'https://facebook.com',
    growthinvest_integrations: 'https://growthinvest.com/integrations/',
    growthinvest_investor_tcs: 'https://growthinvest.com/investor-terms-and-conditions/',
    growthinvest_knowledge_centre: 'https://growthinvest.com/knowledge-centre-welcome/',
    growthinvest_loss_relief_factsheet:
        'https://growthinvestlivesite.s3.amazonaws.com/Platform+Documents/1GrowthInvest/Other/Factsheet+-+Loss+Relief.pdf',
    growthinvest_privacy_agreement: 'https://growthinvest.com/privacy-policy/',
    growthinvest_risk_summary: 'https://growthinvest.com/risk-summaries/',
    growthinvest_vct_buyback_calendar: 'https://growthinvest.com/vct-buy-back-calendar-requested/',
    growthinvest_vct_case_study: 'https://growthinvest.com/vct-case-study/',
    growthinvest_ways_to_pay: 'https://growthinvest.com/ways-to-pay/',
    hmrc_guidance_on_loss_relief: 'https://www.gov.uk/government/publications/losses-hs227-self-assessment-helpsheet',
    hmrc_guide_to_eis_relief:
        'https://www.gov.uk/government/publications/enterprise-investment-scheme-income-tax-relief-hs341-self-assessment-helpsheet',
    hmrc_guide_to_seis_relief:
        'https://www.gov.uk/government/publications/seed-enterprise-investment-scheme-income-tax-and-capital-gains-tax-reliefs-hs393-self-assessment-helpsheet',
    hmrc_negligible_value_claims:
        'https://www.gov.uk/government/publications/negligible-value-claims-and-income-tax-losses-on-disposals-of-shares-you-have-subscribed-for-in-qualifying-trading-companies-hs286-self-assessment-he',
    james_brearley_oep:
        'https://www.jbrearley.co.uk/individual-investors/wp-content/uploads/2023/08/Order-Execution-Policy-Aug-23.pdf',
    james_brearley_privacy_policy: 'https://www.jbrearley.co.uk/privacy-policy/',
    james_brearley_tcs:
        'https://www.jbrearley.co.uk/individual-investors/wp-content/uploads/2024/06/JB-Service-Terms-and-Conditions-JUNE-2024-1.pdf',
    linkedin: 'https://linkedin.com',
    lse: 'https://www.londonstockexchange.com',
    twitter: 'https://twitter.com',
    woodside_tcs: 'https://woodsidecorporateservices.co.uk/WCSL_Investor-Terms-and-Conditions.pdf'
};

export default external_urls;
